import React,{useState} from 'react';
import { BaseURL } from '../URLs';

import { getLocalStorageItem } from '../localStorageUtils';
import moment from 'moment';
import { loaderService } from '../custom-loader/loader-service';
import apiClient from '../../axios';

const Context = React.createContext();
// const auth = "Bearer "+getLocalStorageItem('id_token')

export const ContextProvider =({children}) =>{

//.....................GET TICKET DETAILS ...............................//////

    const [allTicket,setAllTicket]= useState([]);

    const getTicketListforAdmin =()=>{
        loaderService.showLoader();
        apiClient.post(BaseURL+"/grievanceandhelpdesk/v1/helpdesk/getTicketListForAdmin",
        {},
        {
        headers:{
            Authorization: "Bearer " + getLocalStorageItem('id_token')
        }
        }
        ).then((response)=>{
            // console.log("Data - ", response.data);
            let tempData = [...response.data];
            for (let index = 0; index < tempData.length; index++) {
                const element = tempData[index];
                element.createdDateStr = convertDate(element.createdDateStr);
                element.dueDateStr = convertDate(element.dueDateStr);
                element.raisedDateStr = convertDate(element.raisedDateStr);
                element.updatedDateStr = convertDate(element.updatedDateStr);
            }
    
            setAllTicket(tempData);
            loaderService.hideLoader();
        }).catch((error)=>{
            console.log(error);
            loaderService.hideLoader();
        })        
    }

    const getTicketListforExecutive =()=>{
        loaderService.showLoader();
        apiClient.post(BaseURL+"/grievanceandhelpdesk/v1/helpdesk/findAssignedTicketList",
        {},
        {
        headers:{
            Authorization: "Bearer " + getLocalStorageItem('id_token')
        }
        }
        ).then((response)=>{
            // console.log("Data - ", response.data);
            let tempData = [...response.data];
            for (let index = 0; index < tempData.length; index++) {
                const element = tempData[index];
                element.createdDateStr = convertDate(element.createdDateStr);
                element.dueDateStr = convertDate(element.dueDateStr);
                element.raisedDateStr = convertDate(element.raisedDateStr);
                element.updatedDateStr = convertDate(element.updatedDateStr);
            }
            setAllTicket(tempData);
            loaderService.hideLoader();
        }).catch((error)=>{
            console.log(error);
            loaderService.hideLoader();
        })        
    }

    const getTicketListfunc=()=>{
        loaderService.showLoader();
        apiClient.post(BaseURL+"/grievanceandhelpdesk/v1/helpdesk/getTicketList",
        {},
        {
        headers:{
            Authorization: "Bearer " + getLocalStorageItem('id_token')
        }
        }
        ).then((response)=>{
            // console.log("Data - ", response.data);
            let tempData = [...response.data];
            for (let index = 0; index < tempData.length; index++) {
                const element = tempData[index];
                element.createdDateStr = convertDate(element.createdDateStr);
                element.dueDateStr = convertDate(element.dueDateStr);
                element.raisedDateStr = convertDate(element.raisedDateStr);
                element.updatedDateStr = convertDate(element.updatedDateStr);
            }

            setAllTicket(tempData);
            loaderService.hideLoader();
        }).catch((error)=>{
            console.log(error);
            loaderService.hideLoader();
        })        
}



const convertDate = (date)=>{
    return moment(date, "YYYY-MM-DD hh:mm:ss").format('DD/MM/YYYY hh:mm:ss')
  }

///..............GET USER DETAILS.................//

    // const [userdet,setUserdet] = useState();
    // const getUserdetfunc=()=>{
    //     apiClient.post(BaseURL+"/grievanceandhelpdesk/v1/helpdesk/getUserDetails",
    //     {},
    //     {
    //     headers:{
    //         Authorization: "Bearer " + getLocalStorageItem('id_token')
    //     }
    //     }
    //     ).then((response)=>{
    //         //console.log("Data - ");
    //         setUserdet(response.data);
    //     }).catch((error)=>{
    //         console.log(error);
    //     })      
    // }
    return(
        <Context.Provider value={{ticketlist:[allTicket, getTicketListforAdmin, getTicketListforExecutive, getTicketListfunc] }}>
            {children}
        </Context.Provider>
    )
}

export default Context;